import { getBranch } from "utils/utils";
import moment from "moment";
import { UPDATE_SEARCHTDATA_INNHANHDANHSACHDONDATHANG } from "../../actions/DanhSachDonDatHang/actionTypes";

const initialState = {
  ExInNhanh: [],
};

const updateInNhanhDanhSachDonDatHang = (state, action) => ({
  ...action.payload,
});

export const inNhanhDanhSachDonDatHang = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_INNHANHDANHSACHDONDATHANG:
      return updateInNhanhDanhSachDonDatHang(state, action);
    default:
      return state;
  }
};

export default inNhanhDanhSachDonDatHang;
